import { Grid } from "@mui/material"
import AccountHeader from "../AccountHeader"
import StoreListCard from "./StoreListCard"
import { useTranslation } from "react-i18next"
import { STORE_ICON_URLS } from "../StoreIconUrls"

export default function StoreList() {
  const [t] = useTranslation('account-v2')

  return <div>
    <AccountHeader
      title={t('Add a store')}
    />

    <Grid container spacing={4}>
      <StoreListCard
        slug="shopify"
        name="Shopify"
        image={STORE_ICON_URLS.shopify}
        description={t('Run a full online store with flexible storefronts, product publishing, and native checkout.')}
      />
      <StoreListCard
        slug="squarespace"
        name="Squarespace"
        image={STORE_ICON_URLS.squarespace}
        description={t('Sell through a polished website builder with integrated products, pages, and branded storefront design.')}
      />
      <StoreListCard
        slug="etsy"
        name="Etsy"
        image={STORE_ICON_URLS.etsy}
        description={t('Sell through a built-in marketplace where Etsy helps shoppers discover your products and purchase from your shop.')}
      />
      <StoreListCard
        slug="bigcartel"
        name="Big Cartel"
        image={STORE_ICON_URLS.bigcartel}
        description={t('Manage a simple independent storefront built for makers, artists, and small product catalogs.')}
      />
    </Grid>
  </div>
}
